<!-- 账号管理 -->
<template>
  <div class="manage page_width">
    <div class="manage_header">
      <page-header
        icon="iconzhanghaoguanli"
        label="账号管理">
      </page-header>
    </div>
    <div class="manage_main tw-flex">
      <div class="manage_main_left">
        <div class="custom_menu">
          <el-menu
            class="my-el-menu-no-border"
            :default-active="$route.meta.sidebar"
            :unique-opened="true"
            :default-openeds="['1']"
            :router="true">
            <el-submenu index="1">
              <p
                class="menu_item_title"
                slot="title">
                用户账号管理
              </p>
              <el-menu-item index="/account-manage/user-list">
                <p
                  class="sub_menu_item_title"
                  slot="title">
                  用户列表
                </p>
              </el-menu-item>
              <el-menu-item index="/account-manage/rz-audit">
                <p
                  class="sub_menu_item_title"
                  slot="title">
                  入驻审核
                </p>
              </el-menu-item>
              <!-- <el-menu-item index="gk-audit">
                <p class="sub_menu_item_title">挂靠审核</p>
              </el-menu-item> -->
              <el-menu-item index="/account-manage/jcs-audit">
                <p
                  class="sub_menu_item_title"
                  slot="title">
                  集成商认证
                </p>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/account-manage/admin-manage" v-if="role !== globalVar.ADMIN_ROLE_2">
              <p
                class="menu_item_title"
                slot="title">
                后台运营成员
              </p>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="manage_main_right tw-flex-1">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.manage {
  margin-bottom: 25px;
  &_header {
    padding: 30px 0 20px 0;
  }
  &_main {
    &_left {
      width: 200px;
      margin-right: 20px;
    }
    &_right {
      width: 980px;
    }
  }
}

.custom_menu {
  padding: 10px 0;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: hidden;
  .menu_item_title, .sub_menu_item_title {
    position: relative;
    color: #606266;
    &::before {
      content: "";
      position: absolute;
      height: 100%;
      left: -20px;
      width: 4px;
      background-color: transparent;
    }
  }
  .sub_menu_item_title {
    &::before {
      left: -40px;
    }
  }
  .el-menu-item.is-active {
    .menu_item_title, .sub_menu_item_title {
      color: #3473E6;
      font-weight: bold;
      &::before {
        background-color: #3473E6;
      }
    }
  }
}
</style>
